export default function ComparisonTable() {
  const rows = [
    { feature: 'Templates', basetao: 'Advanced', excel: 'Basic', sheets: 'Medium' },
    { feature: 'Collaboration', basetao: 'High', excel: 'Medium', sheets: 'High' },
    { feature: 'Automation', basetao: 'Advanced', excel: 'Limited', sheets: 'Medium' },
    { feature: 'Business Workflow', basetao: 'Excellent', excel: 'Good', sheets: 'Good' },
    { feature: 'Learning Curve', basetao: 'Easy', excel: 'Medium', sheets: 'Easy' },
    { feature: 'Order Tracking', basetao: 'Built-in', excel: 'Manual', sheets: 'Manual' },
    { feature: 'Cost Calculation', basetao: 'Automated', excel: 'Formula Only', sheets: 'Formula Only' },
    { feature: 'Basetao Integration', basetao: 'Native', excel: 'None', sheets: 'None' },
  ];

  const getCellClass = (value: string, col: string) => {
    if (col === 'basetao') {
      if (['Advanced', 'High', 'Excellent', 'Easy', 'Built-in', 'Automated', 'Native'].includes(value)) {
        return 'text-secondary-700 font-semibold';
      }
    }
    return 'text-foreground-700';
  };

  return (
    <section id="comparison" className="py-16 md:py-20 px-4 md:px-6">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block text-xs font-semibold tracking-wider uppercase text-accent-700 bg-accent-100 px-3 py-1 rounded-full mb-4">
            Tool Comparison
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            Basetao Spreadsheet Compared With Traditional Tools
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            See how Basetao Spreadsheet stacks up against Excel and Google Sheets across key dimensions that matter for e-commerce sourcing.
          </p>
        </div>

        <div className="overflow-x-auto rounded-xl border border-background-200/70">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-background-100">
                <th className="text-left px-5 py-3.5 font-semibold text-foreground-900 whitespace-nowrap">Feature</th>
                <th className="text-left px-5 py-3.5 font-semibold text-primary-700 whitespace-nowrap">
                  <span className="flex items-center gap-1.5">
                    <i className="ri-star-fill w-4 h-4 flex items-center justify-center"></i>
                    Basetao Spreadsheet
                  </span>
                </th>
                <th className="text-left px-5 py-3.5 font-semibold text-foreground-800 whitespace-nowrap">Excel</th>
                <th className="text-left px-5 py-3.5 font-semibold text-foreground-800 whitespace-nowrap">Google Sheets</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, idx) => (
                <tr key={row.feature} className={`border-t border-background-200/50 ${idx % 2 === 0 ? 'bg-background-50' : 'bg-background-100/50'}`}>
                  <td className="px-5 py-3 font-medium text-foreground-800 whitespace-nowrap">{row.feature}</td>
                  <td className={`px-5 py-3 ${getCellClass(row.basetao, 'basetao')} whitespace-nowrap`}>
                    <span className="flex items-center gap-1.5">
                      <i className="ri-check-line w-4 h-4 flex items-center justify-center text-secondary-600"></i>
                      {row.basetao}
                    </span>
                  </td>
                  <td className="px-5 py-3 text-foreground-600 whitespace-nowrap">{row.excel}</td>
                  <td className="px-5 py-3 text-foreground-600 whitespace-nowrap">{row.sheets}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}